import { Flex, Link, Text } from '@approvalmax/ui/src/components';
import { intl } from '@approvalmax/utils';
import moment from 'moment';
import { getPath, Path } from 'urlBuilder';

import { messages } from './BillFooter.messages';
import { BillFooterProps } from './BillFooter.types';

export const BillFooter = (props: BillFooterProps) => {
    const { request, lineNumber, matchingLines } = props;

    const matchingInfo = matchingLines.find(({ documentLineNumber }) => documentLineNumber === lineNumber);

    if (!matchingInfo) {
        return null;
    }

    return (
        <Flex>
            <Link
                font='label'
                fontSize='small'
                fontWeight='medium'
                href={getPath(Path.request, matchingInfo.requestId, request.companyId)}
                external
            >
                {matchingInfo.friendlyName}
            </Link>

            <Flex spacing='4'>
                <Text font='label' fontSize='small'>
                    {messages.date}
                </Text>

                <Text font='label' fontSize='small' fontWeight='medium'>
                    {moment.utc(matchingInfo.date).format('ll')}
                </Text>
            </Flex>

            <Flex spacing='4'>
                <Text font='label' fontSize='small'>
                    {messages.amount}
                </Text>

                <Text font='label' fontSize='small' fontWeight='medium'>
                    {intl.formatCurrency(matchingInfo.totalAmount, request.currency)}
                </Text>
            </Flex>
        </Flex>
    );
};

BillFooter.displayName = 'BillFooter';
